export { Component } from './page.component'
